import React, { FC } from 'react';
import RecentInsights from './RecentInsights';
import Insight from './Insight';
import RelatedArticle from './RelatedArticle';
import { CardProps, CARD } from './models.d';

const Card: FC<CardProps> = ({
  variant = CARD.VARIANT.RECENT_INSIGHTS,
  recentInsightsProps,
}) => {
  const renderCard = () => {
    switch (variant) {
      case CARD.VARIANT.RECENT_INSIGHTS:
        return <RecentInsights {...recentInsightsProps!} />;
      case CARD.VARIANT.INSIGHT:
        return <Insight {...recentInsightsProps!} />;
      case CARD.VARIANT.RELATED_ARTICLE:
        return <RelatedArticle {...recentInsightsProps!} />;
      default:
        return null;
    }
  };

  return renderCard();
};

export default Card;
